/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LinerInspectionReportInclusions } from './LinerInspectionReportInclusions';
import {
    LinerInspectionReportInclusionsFromJSON,
    LinerInspectionReportInclusionsFromJSONTyped,
    LinerInspectionReportInclusionsToJSON,
    LinerInspectionReportInclusionsToJSONTyped,
} from './LinerInspectionReportInclusions';
import type { ReportGeneratorRequest } from './ReportGeneratorRequest';
import {
    ReportGeneratorRequestFromJSON,
    ReportGeneratorRequestFromJSONTyped,
    ReportGeneratorRequestToJSON,
    ReportGeneratorRequestToJSONTyped,
} from './ReportGeneratorRequest';
import type { ReportExportFormats } from './ReportExportFormats';
import {
    ReportExportFormatsFromJSON,
    ReportExportFormatsFromJSONTyped,
    ReportExportFormatsToJSON,
    ReportExportFormatsToJSONTyped,
} from './ReportExportFormats';
import type { ReportResponseTypes } from './ReportResponseTypes';
import {
    ReportResponseTypesFromJSON,
    ReportResponseTypesFromJSONTyped,
    ReportResponseTypesToJSON,
    ReportResponseTypesToJSONTyped,
} from './ReportResponseTypes';
import type { ReportTypes } from './ReportTypes';
import {
    ReportTypesFromJSON,
    ReportTypesFromJSONTyped,
    ReportTypesToJSON,
    ReportTypesToJSONTyped,
} from './ReportTypes';
import type { LinerInspectionReportGeneratorWallRequest } from './LinerInspectionReportGeneratorWallRequest';
import {
    LinerInspectionReportGeneratorWallRequestFromJSON,
    LinerInspectionReportGeneratorWallRequestFromJSONTyped,
    LinerInspectionReportGeneratorWallRequestToJSON,
    LinerInspectionReportGeneratorWallRequestToJSONTyped,
} from './LinerInspectionReportGeneratorWallRequest';

/**
 * 
 * @export
 * @interface LinerInspectionReportGeneratorRequest
 */
export interface LinerInspectionReportGeneratorRequest extends ReportGeneratorRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof LinerInspectionReportGeneratorRequest
     */
    assetFileIds?: Array<number>;
    /**
     * 
     * @type {Array<LinerInspectionReportGeneratorWallRequest>}
     * @memberof LinerInspectionReportGeneratorRequest
     */
    walls?: Array<LinerInspectionReportGeneratorWallRequest>;
    /**
     * 
     * @type {Array<LinerInspectionReportInclusions>}
     * @memberof LinerInspectionReportGeneratorRequest
     */
    inclusions?: Array<LinerInspectionReportInclusions>;
}



/**
 * Check if a given object implements the LinerInspectionReportGeneratorRequest interface.
 */
export function instanceOfLinerInspectionReportGeneratorRequest(value: object): value is LinerInspectionReportGeneratorRequest {
    return true;
}

export function LinerInspectionReportGeneratorRequestFromJSON(json: any): LinerInspectionReportGeneratorRequest {
    return LinerInspectionReportGeneratorRequestFromJSONTyped(json, false);
}

export function LinerInspectionReportGeneratorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinerInspectionReportGeneratorRequest {
    if (json == null) {
        return json;
    }
    return {
        ...ReportGeneratorRequestFromJSONTyped(json, true),
        'assetFileIds': json['assetFileIds'] == null ? undefined : json['assetFileIds'],
        'walls': json['walls'] == null ? undefined : ((json['walls'] as Array<any>).map(LinerInspectionReportGeneratorWallRequestFromJSON)),
        'inclusions': json['inclusions'] == null ? undefined : ((json['inclusions'] as Array<any>).map(LinerInspectionReportInclusionsFromJSON)),
    };
}

export function LinerInspectionReportGeneratorRequestToJSON(json: any): LinerInspectionReportGeneratorRequest {
    return LinerInspectionReportGeneratorRequestToJSONTyped(json, false);
}

export function LinerInspectionReportGeneratorRequestToJSONTyped(value?: LinerInspectionReportGeneratorRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...ReportGeneratorRequestToJSONTyped(value, true),
        'assetFileIds': value['assetFileIds'],
        'walls': value['walls'] == null ? undefined : ((value['walls'] as Array<any>).map(LinerInspectionReportGeneratorWallRequestToJSON)),
        'inclusions': value['inclusions'] == null ? undefined : ((value['inclusions'] as Array<any>).map(LinerInspectionReportInclusionsToJSON)),
    };
}

